import React from 'react';
import I18n from 'app/i18n';
import {
    ExternalAuthFlowOptions,
    PendingLinkResponse,
    showExternalAuthError,
    showExternalLinkConfirmation,
    showExternalRegistrationSuccess,
    startExternalAuthFlow
} from 'app/utils/externalAuth';

const REGISTRATION_ERROR_KEYS = [
    'steam_id_required',
    'steam_already_linked',
    'failed_to_authenticate',
    'steam_unavailable'
];

const LINK_ERROR_KEYS = [
    'failed_to_link_account',
    'steam_already_linked',
    'user_already_linked',
    'steam_unavailable',
    'invalid_or_expired_link'
];

interface PendingSteamLink extends PendingLinkResponse {
    steam_id?: string
    nickname?: string | null
    avatar?: string | null
}

const renderPendingSteamLink = (data: PendingSteamLink): React.ReactNode => <>
    {data.avatar && <img
        src={data.avatar}
        alt={data.nickname || 'Steam'}
        width={64}
        height={64}
    />}
    <p>{I18n.t('steam.labels.confirm_link_account')}</p>
    {data.nickname && <p><strong>{data.nickname}</strong></p>}
</>;

export const startSteamAuthFlow = (options?: ExternalAuthFlowOptions): void => startExternalAuthFlow(
    '/auth/steam',
    options
);

export const showSteamAuthError = (): void => showExternalAuthError('steam', REGISTRATION_ERROR_KEYS);

export const showSteamRegistrationSuccess = (): void => showExternalRegistrationSuccess('steam');

export const showSteamLinkConfirmation = (steamLinked: boolean): void => showExternalLinkConfirmation({
    errorKeys: LINK_ERROR_KEYS,
    linked: steamLinked,
    provider: 'steam',
    renderDetails: renderPendingSteamLink
});
